let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cHuTU")).then(() => parcelRequire('jLUA6'));